import { Box, Flex, Image, Title, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { Feature_Items } from "~/core";
import { useDirectus } from "~/shared/utils/directus/useDirectus";

export const ColumnItem: FC<Feature_Items> = ({
  id,
  image,
  title,
  description,
  additional_image,
}) => {
  const { getDirectusImage } = useDirectus();
  const mImage = additional_image?.image?.id ?? "";
  const mdImage = additional_image?.tablet_image?.id ?? mImage;
  const dImage = additional_image?.desktop_image?.id ?? mdImage;

  return (
    <Flex
      key={id}
      width="100%"
      maxWidth={1240}
      align={"start"}
      justify={"flex-start"}
      gap={4}
      d={{
        bg: "linear-gradient(90deg, var(--colors-surface-neutral-dark-default) 24.35%, var(--colors-surface-primary-dark) 91.53%)",
        gap: 16,
        align: "center",
      }}
    >
      <Flex
        gap={16}
        width="100%"
        maxWidth={1240}
        align="start"
        justify="start"
        md={{ justify: "flex-start", align: "center" }}
        d={{
          flexDirection: "row",
          justify: "normal",
          gap: 64,
          maxWidth: 1240,
          width: "100%",
        }}
      >
        <Box width="max-content">
          <Image
            minWidth={100}
            d={{ width: 184, height: 160 }}
            value={getDirectusImage(image?.id ?? "", {
              format: "webp",
              width: 100,
            })}
            dValue={getDirectusImage(image?.id ?? "", {
              format: "webp",
              width: 184,
            })}
          />
        </Box>
        <Flex
          flexDirection="column"
          justify="center"
          align={"flex-start"}
          width="max-content"
          md={{ justify: "flex-start", align: "flex-start" }}
          d={{ justify: "normal", align: "flex-start" }}
        >
          <Title
            size="small"
            as="h4"
            fontWeight="mobile.semibold"
            fontSize="title.mobile.medium"
            lineHeight="title.mobile.medium"
            horizontalAlign="left"
            m={{ mb: 8 }}
            md={{
              maxWidth: "64%",
              width: "100%",
              fontWeight: "desktop.bold",
              fontSize: "title.desktop.small",
              lineHeight: "title.desktop.small",
            }}
          >
            {title}
          </Title>
          {description && (
            <Typography
              size="medium"
              horizontalAlign="left"
              md={{ maxWidth: "64%" }}
              m={{ mb: 8 }}
            >
              {description}
            </Typography>
          )}
          {additional_image?.image && (
            <Image
              value={getDirectusImage(mImage, {
                format: "webp",
                width: additional_image.mobile_image_width ?? undefined,
                height: additional_image.mobile_image_height ?? undefined,
              })}
              mdValue={getDirectusImage(mdImage, {
                format: "webp",
                width: additional_image.tablet_image_width ?? undefined,
                height: additional_image.tablet_image_height ?? undefined,
              })}
              dValue={getDirectusImage(dImage, {
                format: "webp",
                width: additional_image.desktop_image_width ?? undefined,
                height: additional_image.desktop_image_height ?? undefined,
              })}
            />
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};
